export default "__VITE_ASSET__BWgYBb2F__"